import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { Row, Col } from 'react-bootstrap';

import { authModule, chatModule, communicationModule, getLogger } from '@chedri/base';

import { mayUseAudioCall, mayUseVideoCall } from 'helpers/webrtccall';

import CommunicationUserInfo from './CommunicationUserInfo';

const logger = getLogger('communication');

function CommunicationHeader({ me, contact }) {
  const dispatch = useDispatch();

  const meIsEmployee = useSelector(authModule.selectors.isEmployee);
  const hasActiveConversation = useSelector(chatModule.selectors.hasActiveConversation);
  const isAgent = useSelector(communicationModule.selectors.isAgent);
  const isEndChatPending = useSelector(chatModule.selectors.isConversationClosing(contact && contact.id));
  const isConversationClosed = useSelector(chatModule.selectors.isConversationClosed(contact && contact.id));
  const isCustomerChat = contact && (contact.customer_chat_id || (contact && contact.role === 'customer'));
  const isChatEnded = isCustomerChat && (isConversationClosed || !contact || !contact.is_online);

  const agentChange = useCallback(
    newStatus => {
      logger.debug('Set agent status from', isAgent, 'to', newStatus);
      if (newStatus) {
        Promise.all([mayUseAudioCall(), mayUseVideoCall()])
          .then(([isAudioCallAvailable, isVideoCallAvailable]) => {
            const action = communicationModule.actions.enableAgent({
              isAudioCallAvailable,
              isVideoCallAvailable,
            });
            logger.debug('Enable agent', action);
            dispatch(action);
          })
          .catch(err => logger.error('Error toggling agent status', err));
      } else {
        logger.debug('Disable agent');
        dispatch(communicationModule.actions.disableAgent());
      }
    },
    [dispatch, isAgent]
  );

  const endChat = useCallback(() => {
    dispatch(chatModule.actions.closeCustomerChat(contact.id));
  }, [contact]);
  return (
    <Row className="ccc-header">
      <Col xs={hasActiveConversation ? 4 : 3}>
        <CommunicationUserInfo
          user={me && me.profile}
          isEmployee={meIsEmployee}
          isAgent={isAgent}
          onAgentChange={agentChange}
        />
      </Col>
      <Col xs={hasActiveConversation ? 8 : 9}>
        {hasActiveConversation && contact && (
          <CommunicationUserInfo
            user={contact}
            isOnline={contact.is_online}
            onEndChat={endChat}
            isEndChatPending={isEndChatPending}
            isChatEnded={isChatEnded}
          />
        )}
      </Col>
    </Row>
  );
}
CommunicationHeader.defaultProps = {
  contact: null,
};
CommunicationHeader.propTypes = {
  me: PropTypes.object.isRequired,
  contact: PropTypes.object,
};

export default CommunicationHeader;
